export var SeatPickerLegendItemType;
(function (SeatPickerLegendItemType) {
    SeatPickerLegendItemType["Normal"] = "Normal";
    SeatPickerLegendItemType["Wheelchair"] = "Wheelchair";
    SeatPickerLegendItemType["Companion"] = "Companion";
    SeatPickerLegendItemType["Sofa"] = "Sofa";
    SeatPickerLegendItemType["Friend"] = "Friend";
})(SeatPickerLegendItemType || (SeatPickerLegendItemType = {}));
